import { Component } from '@angular/core';

import { AbstractCellComponent } from '@camelot/core';

import { PaymentFlowStatus } from '../../../services/dto/payment-flow-status';
import { PaymentFlowStatusComponent } from '../../payment-flow-status/payment-flow-status.component';

@Component({
  host: { 'data-cid': 'grid-payment-flow-status-cell' },
  imports: [PaymentFlowStatusComponent],
  selector: '',
  template: `<div class="align-center" style="height: 100%">
    <cam-payment-flow-status [status]="this.status"></cam-payment-flow-status>
  </div>`,
})
export class GridPaymentFlowStatusCellComponent extends AbstractCellComponent<any, PaymentFlowStatus> {
  get status() {
    return this.value ?? PaymentFlowStatus.Unknown;
  }
}
